import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "./Solutions.css";

const Solutions = () => {
  const useCases = [
    { icon: "fa-gavel", title: "Legal Teams", desc: "Instantly search through contracts, case files, and compliance documents. Get citation-backed answers to complex legal queries.", tag: "Most Popular" },
    { icon: "fa-chart-line", title: "Finance & Analysts", desc: "Analyze financial reports, earnings calls, and market research. Extract key metrics and trends from hundreds of documents.", tag: "" },
    { icon: "fa-graduation-cap", title: "Education & Research", desc: "Process academic papers, textbooks, and research materials. Generate literature reviews and find connections across sources.", tag: "" },
    { icon: "fa-heartbeat", title: "Healthcare", desc: "Navigate clinical guidelines, medical literature, and patient records. HIPAA-compliant processing for sensitive health data.", tag: "" },
    { icon: "fa-cogs", title: "Engineering & Product", desc: "Search through technical documentation, RFCs, and product specs. Onboard new team members faster with AI-guided knowledge.", tag: "" },
    { icon: "fa-headset", title: "Customer Support", desc: "Build intelligent support bots that answer from your actual documentation. Reduce ticket volume by 40% with accurate AI responses.", tag: "New" },
  ];

  return (
    <div className="solutions-page">
      <section className="solutions-hero">
        <div className="solutions-badge"><span className="badge-dot"></span> Use Cases</div>
        <h1>Solutions for<br /><span className="gradient-text">every industry</span></h1>
        <p>See how teams across different sectors use Contextly AI to unlock insights from their documents.</p>
      </section>

      <section className="solutions-grid-section">
        <div className="solutions-grid">
          {useCases.map((uc, i) => (
            <div key={i} className="solution-card">
              {uc.tag && <div className="solution-tag">{uc.tag}</div>}
              <div className="solution-icon"><i className={`fa ${uc.icon}`}></i></div>
              <h3>{uc.title}</h3>
              <p>{uc.desc}</p>
              <Link to="/" className="solution-link">Learn more <i className="fa fa-arrow-right"></i></Link>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Solutions;
